export default __webpack_public_path__ + "static/media/workpacks.3558c628.svg";